import React from 'react';
import BaseInput from './Input/BaseInput';
import BaseSelect from './Select/BaseSelect';
import BaseButton from './Button/BaseButton';
import Calendar from './Calendar/calendar';
import Time from './Time/time';
import BaseCheckbox from './CheckBox';
import DashCard from '../DashCard';
import Card from '../Card';

let lastAutoAdvanceAt = 0;

const FormComp = ({ dados, handleInputChange, layout = 'default', className = '' }) => {
    const tryFocusByLabel = (labelText) => {
        if (!labelText) return;
        const labels = Array.from(document.querySelectorAll('label'));
        const target = labels.find(l => l.textContent && l.textContent.trim().toLowerCase() === String(labelText).toLowerCase());
        if (target) {
            const forId = target.getAttribute('for');
            if (forId) {
                const input = document.getElementById(forId);
                if (input) {
                    input.focus();
                    if (typeof input.select === 'function') input.select();
                }
            }
        }
    };

    const tryFocusByName = (name) => {
        if (!name) return false;
        const candidates = [
            name,
            String(name).toLowerCase(),
            name === 'nSerie' ? 'nserie' : null,
            name === 'nMac' ? 'nmac' : null,
            name === 'nEtiqueta' ? 'netiqueta' : null,
        ].filter(Boolean);
        for (const candidate of candidates) {
            const el = document.querySelector(`input[name='${candidate}']`);
            if (el) {
                el.focus();
                if (typeof el.select === 'function') el.select();
                return true;
            }
        }
        return false;
    };

    const renderBaseInput = (dados, isNumber = false) => {
        const handleChange = (e) => {
            if (typeof handleInputChange === 'function') {
                handleInputChange(e);
            }
            const valueLen = String(e?.target?.value ?? '').length;
            if (dados?.maxLength && valueLen >= dados.maxLength) {
                // Marca avanço por comprimento máximo para evitar duplo avanço com Enter do leitor
                lastAutoAdvanceAt = Date.now();
                if (!tryFocusByName(dados?.nextInputName)) {
                    tryFocusByLabel(dados?.nextInput);
                }
            }
        };

        const handleKeyDown = (e) => {
            if (e.key === 'Enter' && (dados?.nextInputName || dados?.nextInput)) {
                e.preventDefault();
                // Se acabou de avançar automaticamente, ignore Enter para não pular dois
                if (Date.now() - lastAutoAdvanceAt < 200) {
                    return;
                }
                if (!tryFocusByName(dados?.nextInputName)) {
                    tryFocusByLabel(dados?.nextInput);
                }
            }
        };

        return (
            <BaseInput
                label={dados.titulo}
                name={dados.name}
                value={dados.valor || ''}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                type={isNumber ? 'number' : (dados.type || 'text')}
                required={dados.required}
                disabled={dados.disabled}
                placeholder={dados.placeholder}
                maxLength={dados.maxLength}
                minLength={dados.minLength}
                autoComplete={dados.autoComplete}
                autoFocus={dados.autoFocus}
                readOnly={dados.readOnly}
            />
        );
    };

    const components = {
        Dashcard: <DashCard titulo={dados.titulo} valor={dados.valor} />,
        NumberInput: (
            renderBaseInput(dados, true)
        ),
        Input: (
            renderBaseInput(dados, false)
        ),
        Select: (
            <BaseSelect
                label={dados.titulo}
                name={dados.name}
                value={dados.valorSelect || dados.valor || ''}
                onChange={handleInputChange}
                options={dados.options || []}
                placeholder={dados.placeholder || "Selecione uma opção"}
                required={dados.required}
                disabled={dados.disabled}
                valueKey={dados.valueKey || "id"}
                labelKey={dados.labelKey || "nome"}
            />
        ),
        Calendar: <Calendar dados={dados} handleInputChange={handleInputChange} />,
        Time: <Time dados={dados} handleInputChange={handleInputChange} />,
        Checkbox: <BaseCheckbox 
      id={dados.name} 
      name={dados.name} 
      checked={dados.valor} 
      onChange={(e) => handleInputChange(e, dados.index)} 
      label={dados.titulo}
      variant="primary"
      size="md"
    />,
    };

    const formClasses = [
        layout === 'clean' ? 'w-full' : layout === 'modal' ? 'w-full' : 'w-full p-4 bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700',
        layout === 'compact' ? 'p-2' : '',
        layout === 'wide' ? 'max-w-none' : layout === 'clean' ? 'max-w-none' : layout === 'modal' ? 'max-w-none' : 'max-w-md',
        className
    ].filter(Boolean).join(' ');

    // Se for um DashCard, retorna diretamente
    if (dados.tipo === 'Dashcard') {
        return components[dados.tipo];
    }

    // Para outros componentes, pode ser envolvido em um card se necessário
    if (dados.wrapInCard) {
        return (
            <Card 
                title={dados.cardTitle}
                subtitle={dados.cardSubtitle}
                variant={dados.cardVariant || 'default'}
                className="shadow-vox-lg"
            >
                <div className={formClasses}>
                    {components[dados.tipo]}
                </div>
            </Card>
        );
    }

    // Para layout modal, não envolver em div adicional
    if (layout === 'modal') {
        return components[dados.tipo];
    }

    return (
        <div className={formClasses}>
            {components[dados.tipo]}
        </div>
    );
};

export default FormComp;
